import React, { useEffect, useState } from "react";
import ConfirmacionID from "./componentes/confirmacionID/ConfirmacionID";
import Form from "./componentes/form/Form";

function App() {
  const [savePathname, setSavePathname] = useState([]);
  const [saveId, setSaveId] = useState([]);
  function getUrl() {
    var actual = window.location.href;
    var actualId = new URLSearchParams(window.location.search);
    setSavePathname(actual);
    setSaveId(actualId.get("id"));
  }

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <div>
      {/* {savePathname === `http://localhost:3000/?id=${saveId}` ? ( */}
      {savePathname ===
      `${process.env.REACT_APP_VALIDATION_URL}?id=${saveId}` ? (
        <ConfirmacionID />
      ) : (
        <Form />
      )}
    </div>
  );
}

export default App;
